export default __webpack_public_path__ + "static/media/prospect_profile.22f1166d.png";